import React from "react";
import { NavLink } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { BsGrid, BsBell } from "react-icons/bs";
import { HiOutlineClipboardList } from "react-icons/hi";
import { FiSettings, FiHelpCircle } from "react-icons/fi";

// import Wallet from images/wallet.svg";

import "../css/sidebar.css";
import Logo from "../images/Arteri-logo.svg";

const Sidebar = ({ setSidebar }) => {
  return (
    <section className="sidebar">
      <NavLink onClick={() => setSidebar(false)} to="/">
        <img src={Logo} alt="" className="logo" />
      </NavLink>
      <ul className="sidebar-list">
        <li className="sidebar-links">
          <NavLink onClick={() => setSidebar(false)} to="/">
            <BsGrid className="sidebar-links-icon" />
            <span className="sidebar-link-text"> Dashboard</span>
          </NavLink>
        </li>
        {/* <li className="sidebar-links">
          <NavLink onClick={()=>setSidebar(false)} to="/withdrawal">
            <BiWalletAlt className="sidebar-links-icon" />
            <span className="sidebar-link-text"> Withdrawal </span>
          </NavLink>
        </li> */}
        <li className="sidebar-links">
          <NavLink onClick={() => setSidebar(false)} to="/account">
            <CgProfile className="sidebar-links-icon" />
            <span className="sidebar-link-text">Account</span>
          </NavLink>
        </li>
        <li className="sidebar-links">
          <NavLink onClick={() => setSidebar(false)} to="/history">
            <HiOutlineClipboardList className="sidebar-links-icon" />

            <span className="sidebar-link-text"> History</span>
          </NavLink>
        </li>
        <li className="sidebar-links">
          <NavLink onClick={() => setSidebar(false)} to="/notifications">
            <BsBell className="sidebar-links-icon" />

            <span className="sidebar-link-text"> Notification</span>
          </NavLink>
        </li>
        <li className="sidebar-links">
          <NavLink onClick={() => setSidebar(false)} to="/settings">
            <FiSettings className="sidebar-links-icon" />

            <span className="sidebar-link-text">Settings </span>
          </NavLink>
        </li>
        <li className="sidebar-links">
          <NavLink onClick={() => setSidebar(false)} to="/help">
            <FiHelpCircle className="sidebar-links-icon" />

            <span className="sidebar-link-text">Help </span>
          </NavLink>
        </li>
      </ul>

      <ul className="account-btns">
        <li onClick={() => setSidebar(false)} className="sidebar-links">
          <button>Switch Account</button>
        </li>
        <li onClick={() => setSidebar(false)} className="sidebar-links">
          <button>
            <BiLogOut className="sidebar-links-icon" />
            <p className="sidebar-link-text"> Logout</p>
          </button>
        </li>
      </ul>
    </section>
  );
};

export default Sidebar;
